export enum PersonType {
    Owner = 'OWNER',
    Partner = 'PARTNER',
}

export function getLocalizedPersonType(): Record<PersonType, string> {
    return {
        'OWNER': $localize`:@@personType.owner:Aangever`,
        'PARTNER': $localize`:@@personType.partner:Partner`,
    };
}
